<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Quick Bulk Message</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickCancel"
                >
                    Cancel
                </v-btn>

               
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="padding-top: 15px;"
        >

            <v-select
                label="Who to message"
                v-model="selected_list_id"
                :items="list_labels"
            />

            <v-textarea
                label="Message"
                auto-grow
                rows="1"
                v-model="message"
            />

            <v-select
                label="Message Type"
                :items="message_type_choices"
                v-model="category"
            />

             <m-legal-agreement
                type="bulk-message-attestation"
                :organization_id="$rc.$state.getOrganizationId()"
                v-model="consent_acknowledgement"
                ref="bulk_message_attestation"
                style="margin-right: 15px; margin-bottom: 15px;"
            />

            <div
                style="text-align: right"
            >
                <v-btn
                    v-on:click="onClickReviewBeforeSend"
                    :disabled="!is_valid"
                    style="margin-right: 15px;"
                >
                    Review Before Sending
                </v-btn>

                <v-btn
                    color="primary"
                    v-on:click="onClickSend"
                    :disabled="!is_valid"
                >
                    Send
                </v-btn>
            </div>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,

            list_meta_data: [],

            selected_list_id: null,
            message: null,
            consent_acknowledgement: false,

            message_type_choices: [
                {'text' : 'Informational', 'value' : 'informational' },
                {'text' : 'Promotional', 'value' : 'promotional' }
            ],

            category: 'promotional',
        }
    },

    methods: {

        showDialog()
        {
            this.category = 'promotional';

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/lists',
            
                {
                    'organization_id' : this.$rc.$state.getOrganizationId(),
                    'is_archived' : false,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.list_meta_data = data.results;
                    this.selected_list_id = null;
                    this.consent_acknowledgement = false;
                    this.message = null;

                    this.dialog = true;
                    this.$router.dialog_guard = this.dialogGuard;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get list information');
                },
            );
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            this.dialog = false;
            next(false);
        },


        onClickCancel()
        {
            this.closeDialog();
        },

        onClickReviewBeforeSend()
        {
            this.preapreMessage(false);
        },

        onClickSend()
        {
            this.preapreMessage(true);
        },

        preapreMessage(send)
        {
            this.closeDialog();
            
            this.$rc.showSpinner();

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'SEND-QUICK: /api/v1/bulk',
            
                'params' :  {
                    'organization_id' : this.$rc.$state.getOrganizationId(),
                    'list_id' : this.selected_list_id,
                    'message' : this.message,
                    'from_endpoint' : this.$route.params.endpoint,
                    'send' : send,
                    'category' : this.category,
                    'specimen_bulk_message_attestation' : this.$refs['bulk_message_attestation'].getSpecimen(),
                },
            
                'on_success': (data) => {
                        
                        if ( data.attestation_signature_error_message != null )
                        {
                            this.$rc.alert('Unable to send bulk message', data.attestation_signature_error_message);
                            return;
                        }

                        this.$router.push({
                            'name': 'view-bulk-message',
                            'params' : {
                                'organization_id' : data.organization_id,
                                'bulk_message_id' : data.bulk_message_id
                            }
                        });
                    },
            
                'on_error': 'Unable to send bulk message.',
            });
        },
    },

    computed: {
        list_labels() {
            let items = [];

            for ( let i = 0; i < this.list_meta_data.length; i++ )
            {
                items.push({
                    'text' : this.list_meta_data[i].list_internal_label + ' ('+this.list_meta_data[i].count_active+')',
                    'value' : this.list_meta_data[i].list_id
                });
            }
            return items;
        },

        is_valid() {
            if ( this.selected_list_id == null ) return false;
            if ( this.message == null || this.message.trim().length == 0 ) return false;
            if ( this.consent_acknowledgement == false ) return false;

            return true;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>